import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const iconWrapper: SxStyleFunc<boolean | undefined> = (isCompany) => ({
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: (p) => p.spacing(1),
  gap: (p) => p.spacing(1),
  my: (p) => p.spacing(1),
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
  background: (p) =>
    isCompany ? p.palette.primary[50] : p.palette.success[50],
});

export const icon: SxStyleFunc<boolean | undefined> = (isCompany) => ({
  color: (p) => (isCompany ? p.palette.primary[500] : p.palette.success[800]),
});

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
};
